var _path, _defs;

const _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSpinnerLight(_ref, svgRef) {
  let {
    title,
    titleId
  } = _ref,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.0389 13.8624C23.0108 14.0427 23.6652 14.9836 23.3424 15.9179C22.708 17.7545 21.6337 19.4187 20.2024 20.7591C18.3333 22.5093 15.9534 23.6158 13.4105 23.9168C10.8676 24.2178 8.29515 23.6975 6.06912 22.4319C3.8431 21.1663 2.08027 19.2219 1.03834 16.8828C-0.00358446 14.5438 -0.269976 11.9328 0.278113 9.43147C0.826202 6.93018 2.16003 4.6698 4.08461 2.98077C6.00918 1.29173 8.42359 0.26262 10.9749 0.0438685C12.9287 -0.123655 14.8843 0.190809 16.674 0.947664C17.5844 1.33267 17.8462 2.44842 17.3301 3.29151C16.8141 4.13461 15.7147 4.3789 14.7817 4.05235C13.6653 3.6616 12.4725 3.5082 11.2807 3.61039C9.49043 3.76389 7.79625 4.48601 6.44577 5.67121C5.0953 6.8564 4.15935 8.44251 3.77476 10.1977C3.39016 11.9528 3.57709 13.785 4.30821 15.4263C5.03933 17.0676 6.27631 18.432 7.83831 19.3201C9.40031 20.2081 11.2054 20.5732 12.9898 20.362C14.7741 20.1508 16.4441 19.3744 17.7556 18.1462C18.6287 17.3286 19.3125 16.3393 19.7688 15.2479C20.1501 14.336 21.067 13.6821 22.0389 13.8624Z",
    fill: "url(#paint0_linear_2737_27328)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2737_27328",
    x1: 12.48,
    y1: 2.4,
    x2: 24.96,
    y2: 16.8,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C7D2FE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F1F5F9",
    stopOpacity: 0.16
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSpinnerLight);
export default __webpack_public_path__ + "static/media/spinner-light.2adcf37baada3bf63a03647b27e09441.svg";
export { ForwardRef as ReactComponent };